export default __webpack_public_path__ + "static/media/view1_month_province.4f6fae2c.csv";